import { observable, computed } from 'mobx';
import { serializable } from 'serializr';
import TimelineEventBase from './../../../shared/timelineevent-base';

export default class TimelineEvent extends TimelineEventBase {
    constructor(...args) {
        super(...args);
    }

    @serializable reminders = [];
    @serializable recurrences = [];
}



// WEBPACK FOOTER //
// ./src/workflow/steps/timeline/timeline-event-model.js